import { render, staticRenderFns } from "./ConfirmDesign.vue?vue&type=template&id=59372fa8"
import script from "./ConfirmDesign.vue?vue&type=script&lang=js"
export * from "./ConfirmDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports